import { connect } from 'react-redux'
import * as formats from '../../constants/formats'
import ExportButton from './ExportButton'
import { exportSelection } from '../../actionCreators'

const maxNumberOfPoints = {
	[formats.PDF]: 50,
	[formats.CSV]: 250,
	[formats.GEOJSON]: 250,
	[formats.K_FIL]: 250,
}

const mapStateToProps = (state, ownProps) => ({
	isExporting: state.isExporting,
	actualCount: state.selectedStompunkter.length,
	allowedCount: maxNumberOfPoints[state.exportSettings.format],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
 	onClick: () => dispatch(exportSelection())
})

export default connect(mapStateToProps, mapDispatchToProps)(ExportButton)



// WEBPACK FOOTER //
// ./src/components/Export/ExportButtonContainer.js